import { combineReducers } from 'redux';
import model from './model/reducer';

export default combineReducers({
	model,
});
